<template>
    <b-card title="Transfer My Rx">
        <b-table id="transfer-my-rx-table"
            api-url="/api/TransferMyRx"
            :items="ctxProvider"
            :fields="fields"
            primary-key="id"
            fixed
        >
            <template #cell(json.patientData)="data">
                {{ data.value.patientFirstName }} {{ data.value.patientLastName }}
            </template>
            <template #cell(json.drugName)="data">
                {{ data.value }}
                <br/>
                {{ data.item.json.drugNDC }}
            </template>
            <template #cell(json.prescriber)="data">
                {{ data.value.lastname }}, {{ data.value.firstname }}
            </template>
            <template #cell(isIncoming)="data">
                {{ data.value ? '✅' : '❌' }}
            </template>
            <template #cell(actions)="data">
                <b-button size="sm" variant="success" @click="approve(data)">Accept</b-button>
                <br/>
                <b-button v-b-modal.reject-reason-modal size="sm" variant="danger" @click="selectedItem = data.item">Reject</b-button>
            </template>
        </b-table>
        <b-modal id="reject-reason-modal" title="Reject Transfer" @ok="rejectWithReason" @hidden="rejectReason = ''">
            <b-form-group label="Reason" label-for="reason-input" >
                <b-form-input id="reason-input" v-model="rejectReason"/>
            </b-form-group>
        </b-modal>
    </b-card>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { BvTableCtxObject } from "bootstrap-vue";
import Axios, { AxiosRequestConfig } from "axios";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

@Component({})
export default class TransferMyRxQueuePage extends Vue {

    protected rejectReason:string = "";
    protected selectedItem:any = null;
    protected fields = [
        "transferMyRxId",
        // {
        //     key: "jsonBody",
        //     class: "json-body-cell",
        // },
        {
            key: "json.toPharmacyData.toPharmacyName",
            label: "To Pharmacy",
        },
        {
            key: "json.fromPharmacyData.fromPharmacyName",
            label: "From Pharmacy",
        },
        {
            key: "json.patientData",
            label: "Patient",
        },
        {
            key: "json.drugName",
            label: "Drug",
        },
        {
            key: "json.prescriber",
            label: "Prescriber",
        },
        {
            key: "json.status",
            label: "Status",
        },
        "isIncoming",
        "actions",
    ];

    async approve(data: any) {
        try {
            const resp = await Axios.post(`/api/TransferMyRx/accept/${data.item.transferMyRxId}`);
            console.log(resp);
            this.$notification(NotificationOptions.success("accepted"));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
        this.refreshTable();
    }

    async rejectWithReason() {
        try {
            const resp = await Axios.post(`/api/TransferMyRx/reject/${this.selectedItem.transferMyRxId}`,{}, {
                params: {
                    reason: this.rejectReason
                }
            });
            console.log(resp);
            this.$notification(NotificationOptions.success("rejected"));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
        this.refreshTable();
    }

    refreshTable() {
        this.$root.$emit('bv::refresh::table', 'transfer-my-rx-table');
    }

    async ctxProvider(ctx: BvTableCtxObject) {
        if (ctx.apiUrl == null) return null;

        const uri = ctx.apiUrl;
        const config: AxiosRequestConfig = {
            params: ctx.filter,
        };
        try {
            const resp = await Axios.get<any[]>(uri, config);
            const items = resp.data.map(tmrx => {
                tmrx.json = JSON.parse(tmrx.jsonBody);
                return tmrx;
            });
            return items;
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
            return [];
        }
    }
}
</script>

<style scoped>

@media (min-width: 900px) {
    ::v-deep(.json-body-cell) {
        width: 750px;
    }
}

</style>
